import React, { useState, useEffect } from 'react';
import Logo from "../images/logo.svg";
import { Navigate, useNavigate } from 'react-router-dom';
import { Message, useToaster } from 'rsuite';
import 'rsuite/dist/rsuite.min.css'; 
import { ReactComponent as PasswordShow } from "../images/icon-eye.svg";
import { ReactComponent as PasswordHide } from "../images/icon-eye-hide.svg";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";
import 'aos/dist/aos.css';
import AOS from 'aos';
import { CgOverflow } from 'react-icons/cg';
import { ChakraProvider, useToast, Wrap } from '@chakra-ui/react'
import { encryptData, decryptData } from "./cryptoUtil";

const Login = () => {
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const [tabName, setTabName] = useState('Login');

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  useEffect(() => {
    AOS.init();
  }, []);

    const toast = useToast()
    const toastIdRef = React.useRef()


  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [messageType, setMessageType] = useState(null); // success, error, info


  const toaster = useToaster();
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleClick = async () => {
      
    
    // const encrypted = encryptData({ data: { username: 'imrohi21@gmail.com', password: 'password', }, });
    // console.log(encrypted);

    // const decrypted = decryptData(JSON.parse(encrypted));
    // console.log(decrypted); // { username: "user", password: "pass" }

     let hasError = false;
     if (!email) {
      toastIdRef.current = toast({ description: 'Please Enter Your Email Address', status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
      hasError = true;
    }
    if (!password) {
      toastIdRef.current = toast({ description: 'Please Enter Your Password', status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
      hasError = true;
    }


 if (!hasError) {
  try {
    // Encrypt the login credentials
    const encrypted = encryptData({
      data: {
        username: email,
        password: password,
        user_agent :navigator.userAgent,
      },
    });

    // Send the encrypted data to the API
    const response = await fetch(`${apiEndPoint}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: encrypted, // encrypted is a JSON string like in your example
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();

    console.log('Encrypted response:', responseData);

    // Decrypt the response if needed
    const decrypted = decryptData(responseData);
    console.log(decrypted);

    if (decrypted.status === 'success') {


      sessionStorage.setItem('userId', decrypted.user_id);
      sessionStorage.setItem('full_name', decrypted.full_name);
      sessionStorage.setItem('email', decrypted.email);
      sessionStorage.setItem('isAdmin', decrypted.is_admin);
      sessionStorage.setItem('isHistoryId', decrypted.isHistoryId);


       toastIdRef.current = toast({ description: decrypted.message, status: 'success', duration: 5000, isClosable: true, position: 'bottom', });
          setTimeout(() => {
            navigate('/Dashboard');
          }, 1000);
    }
    else if (decrypted.status === 'error') {
    toastIdRef.current = toast({ description: decrypted.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
    }
  } catch (error) {
    console.error('Login failed:', error);
  }
}

   

  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        handleClick();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleClick]);

  const hideMessage = () => {
    setMessageType(null);
  };



  return (
    <>
      

       <ChakraProvider resetCSS={false}>
                  <Wrap>
                  
                 </Wrap>
                </ChakraProvider>

      <div className="loader-container">
        <div className={`loader ${isActive ? 'loader--active' : ''}`}>
          <div className="loader__icon">
            <svg width="80" height="80" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_1_591)">
                <rect y="0.282349" width="66.4354" height="66.4354" rx="15.0491" fill="#141B3C" />
                <rect x="17.0926" y="34.8087" width="0" height="7.12692" rx="3.56346" transform="rotate(-38.5482 17.0926 34.8087)" fill="#FDCC72">
                  <animate attributeName="width" dur="2s" from="0" to="71.9071" repeatCount="indefinite" />
                </rect>
                <rect x="13.556" y="50.7231" width="0" height="6.18755" rx="3.09378" transform="rotate(-38.5482 13.556 50.7231)" fill="#FDCC72">
                  <animate attributeName="width" dur="2s" from="0" to="71.9071" repeatCount="indefinite" />
                </rect>
                <path id="line1" d="M-2.48236 42.6675L20.5136 23.3716" stroke="white" strokeWidth="5.89403" strokeLinecap="round" strokeDasharray="150" strokeDashoffset="150">
                  <animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite" from="150" to="0" />
                </path>
                <path id="line2" d="M20.6283 23.5651L40.9626 46.5518" stroke="white" strokeWidth="5.89403" strokeLinecap="round" strokeDasharray="150" strokeDashoffset="150">
                  <animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite" from="150" to="0" />
                </path>
                <path id="line3" d="M41.2585 46.6971L77.2121 17.9658" stroke="white" strokeWidth="5.89403" strokeLinecap="round" strokeDasharray="150" strokeDashoffset="150">
                  <animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite" from="150" to="0" />
                </path>
              </g>
              <defs>
                <clipPath id="clip0_1_591">
                  <rect y="0.282349" width="66.4354" height="66.4354" rx="15.0491" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="loader__tile"></div>
        </div>
      </div>
      
      <div className="login_wrapper" style={{overflow:"hidden"}}>
        
        <div className='login_content' data-aos="fade-up" data-aos-duration="600">
          <div className='login_header'>
            <div className='login_logo'>
              <img src={Logo} alt="Logo" />
            </div>
            <div className='login_header_text'>
              <h3>Welcome Back!</h3>
              <p>Manage investor interactions</p>
              <h6>Investment Platform</h6>
            </div>
          </div>
          <div className='login_form'>
            <form>
              <div className='field_row'>
                <label className='custom_label'>Email Address</label>
                <div className='text_field'>
                  <input type='text' className='form-control' value={email} onChange={(e) => setEmail(e.target.value)}  />
                </div>
              </div>

              <div className='field_row'>
                <label className='custom_label'>Password</label>
                <div className='text_field'>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className='form-control'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)} 
                  />
                  <div className='icon_field' onClick={togglePasswordVisibility}>
                    {showPassword ? <PasswordShow /> : <PasswordHide />}
                  </div>
                </div>
              </div>
              <div className='mt-5'>
                  <button type='button' className='btn_login' onClick={handleClick}>Login</button>
               
              </div>
            </form>
          </div>
        </div>
      </div>
      

    </>
  );
}

export default Login;
